var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 47,
    viewBox: "0 0 46 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9685 11.7867L28.705 34.1624L32.374 34.24L16.6375 11.8644L12.9685 11.7867Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1159 0.468842C10.8763 0.209906 0.740819 10.0932 0.477416 22.5439C0.214013 34.9947 9.92248 45.2977 22.1621 45.5567C34.4017 45.8156 44.5372 35.9323 44.8006 23.4816C45.064 11.0308 35.3555 0.727778 23.1159 0.468842ZM27.8017 35.9046L20.6376 25.7155L11.2958 35.5554L8.94912 35.5057L19.6193 24.267L9.55523 9.95335L17.5418 10.1223L24.1396 19.506L32.7427 10.4439L35.0893 10.4935L25.1579 20.955L35.7883 36.0735L27.8017 35.9046Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.73fde2646b63b9585ed989c15c205b96.svg";
export { ForwardRef as ReactComponent };